import {ctaService} from '../services'

const state = {
    loading: false,
    slots: [],
}

const actions = {

    slots({ dispatch, commit }) {
        commit('startRequestSlots')
        return ctaService.getSlots().then(
            response => {
                commit('successRequestSlots', response)
            },
            error => {
                commit('errorRequestSlots')
                dispatch('alert/error', 'Unable to perform action: ' + error, { root: true })
            }
        )
    },

    add({ dispatch, commit }, params) {
        commit('startRequest')
        return ctaService.add(params).then(
            response => {
                commit('endRequest')
                dispatch('alert/success', 'CTA created successfully', { root: true })
                return response
            },
            error => {
                commit('endRequest')
                dispatch('alert/error', 'Unable to perform action: ' + error, { root: true })
            }
        )
    },

    update({ dispatch, commit }, params) {
        commit('startRequest')
        return ctaService.update(params).then(
            response => {
                commit('endRequest')
                dispatch('alert/success', 'CTA updated successfully', { root: true })
                return response
            },
            error => {
                commit('endRequest')
                dispatch('alert/error', 'Unable to perform action: ' + error, { root: true })
            }
        )
    },

    saveSlot({ dispatch, commit }, params) {
        commit('startRequest')
        return ctaService.saveSlot(params).then(
            response => {
                commit('endRequest')
                dispatch('alert/success', 'Slot updated successfully', { root: true })
                return response
            },
            error => {
                commit('endRequest')
                dispatch('alert/error', 'Unable to perform action: ' + error, { root: true })
            }
        )
    },

    preview({ dispatch, commit }, params) {
        commit('startRequest')
        return ctaService.preview(params).then(
            response => {
                commit('endRequest')
                return response
            },
            error => {
                commit('endRequest')
                dispatch('alert/error', 'Unable to perform action: ' + error, { root: true })
            }
        )
    },

    adSlots({ dispatch, commit }) {
        commit('startRequestSlots')
        return ctaService.getAdSlots().then(
            response => {
                commit('successRequestSlots', response)
            },
            error => {
                commit('errorRequestSlots')
                dispatch('alert/error', 'Unable to perform action: ' + error, { root: true })
            }
        )
    },


}

const mutations = {
    startRequest (state) {
        state.loading = true
    },
    endRequest (state) {
        state.loading = false
    },
    startRequestSlots (state) {
        state.loading = true
        state.slots = []
    },
    successRequestSlots (state, response) {
        state.loading = false
        state.slots = response.rows
    },
    errorRequestSlots (state) {
        state.loading = false
        state.slots = []
    },
}

const getters = {
    isBusy (state) {
        return state.loading === true
    },
    getSlots(state) {
        return state.slots;
    },
    getSlotHeaderTitle: (state, getters) => (slot, slotIndex) => {
        let autolacement = slot.settings.autoplacement;
        let descriptionNumber = '';
        let description = '';

        // special cases
        if (slot.type === ctaModule.SLOT_TYPE.homepage) {
            return '';
        }

        const descriptionAfter = ctaModule.AUTOPLACEMENT_AFTER.find(element => element.value === autolacement.after)
        const descriptionDirection = ctaModule.AUTOPLACEMENT_DIRECTIONS.find(element => element.value === autolacement.direction)
        if (autolacement.paragraph >= 100) {
            descriptionNumber = 'last';
        } else {
            descriptionNumber = getters._ordinalSuffixOf(autolacement.paragraph)
        }

        let descriptionParagraph = "";
        switch(autolacement.selector) {
            case 'p':
                descriptionParagraph = 'Paragraph';
                break;
            case 'hr':
                descriptionParagraph = 'Line Break';
                break;
            case 'h2':
                descriptionParagraph = 'Secondary Header';
                break;
            case 'h3':
                descriptionParagraph = 'Main Header';
                break;
        }

        if (getters._isStartPageSlot(slot)) {
            description = 'At the Top of The Post'
        } else if (getters._isEndPageSlot(slot)) {
            description = 'At the End of The Post'
        } else {
            description = descriptionAfter.text + " " + descriptionNumber + " " + descriptionParagraph + " " + descriptionDirection.text;
        }
        return " - (" + description + ")";
    },
    _isStartPageSlot: (state) => (slot) => {
        let selector = slot.settings.autoplacement.selector
        let after = slot.settings.autoplacement.after
        let paragraph = slot.settings.autoplacement.paragraph
        let direction = slot.settings.autoplacement.direction

        return paragraph == 1 && selector === 'p' && after === 'before' && direction === 'start'
    },
    _isEndPageSlot: (state) => (slot) => {
        let selector = slot.settings.autoplacement.selector
        let after = slot.settings.autoplacement.after
        let paragraph = slot.settings.autoplacement.paragraph
        let direction = slot.settings.autoplacement.direction

        return paragraph == 1 && selector === 'p' && after === 'after' && direction === 'end'
    },
    changeAutoplacementSettingsModeChangeAction: (state) => (slot) => {
        let selector = slot.settings.autoplacement.defaultSelector || 'p'
        let after = slot.settings.autoplacement.defaultAfter || 'after'
        let paragraph = slot.settings.autoplacement.defaultParagraph || 3
        let direction = slot.settings.autoplacement.defaultDirection || 'start'
        let minParagraphs = slot.settings.autoplacement.defaultMinParagraphs || 5
        const mode = slot.settings.autoplacement.mode

        if (mode !== 'manual') {
            paragraph = 1
            selector = 'p'
            minParagraphs = 1

            if (mode === 'start') {
                after = 'before'
                direction = 'start'
            } else if (mode === 'end') {
                after = 'after'
                direction = 'end'
            }
        }

        slot.settings.autoplacement.after = after
        slot.settings.autoplacement.paragraph = paragraph
        slot.settings.autoplacement.selector = selector
        slot.settings.autoplacement.direction = direction
        slot.settings.autoplacement.minParagraphs = minParagraphs
    },
    _ordinalSuffixOf: (state) => (i) =>  {
        var j = i % 10,
            k = i % 100;
        if (j === 1 && k !== 11) {
            return i + "st";
        }
        if (j === 2 && k !== 12) {
            return i + "nd";
        }
        if (j === 3 && k !== 13) {
            return i + "rd";
        }
        return i + "th";
    },
    getCtaPreviewHtml: (state) => (model) => {
        let html = '';
        if (model) {
            let preview = model.preview;

            if (preview.css) {
                html += '<style>' + preview.css + '</style>';
            }
            if (preview.jss) {
                preview.jss.forEach(function (js) {
                    html += `<script src="${js}"><\/script>`;
                });
            }
            if (preview.fonts) {
                preview.fonts.map(font => {
                    html += '<link id="outpost-pub-font" rel="stylesheet" type="text/css" href="https://fonts.googleapis.com/css?family=' + encodeURI(font) + '">';
                })
            }
            if (preview.html) {
                html += `<div class="outpost-pub-container">${preview.html}</div>`;
            }
            if (preview.body) {
                html += preview.body;
            }
        }
        return html;
    },
    getCtaPreviewHtmlDark: (state) => (model) => {
        const html = getters.getCtaPreviewHtml(state)(model)
        return `<html lang="en" data-color-scheme="dark"><style>body {background-color: black;}</style>${html}</html>`;
    }
}

const AUDIENCES = {
    UNKNOWN: 'unknown',
    FREE: 'free',
    MONTHLY: 'monthly',
    ANNUAL: 'annual',
}

const STATUSES = {
    inactive: 'inactive',
    active: 'active',
    archive: 'archive',
}

const SLOT_TYPE = {
    inpost: 'in-post',
    popup: 'popup',
    slideUp: 'bottom-slide-up',
    homepage: 'homepage',
    ad: 'ad',
}

const AUTOPLACEMENT_AFTER = [
    { value: 'after', text: 'After' },
    { value: 'before', text: 'Before' },
]

const AUTOPLACEMENT_DIRECTIONS = [
    { value: 'start', text: 'From the Beginning' },
    { value: 'end', text: 'From the End' },
]

const CTA_TYPE = {
    buttonSubscribe: 'button-subscribe',
    buttonUpgradePaid: 'button-upgrade-paid',
    buttonUpgradeAnnual: 'button-upgrade-annual',
    buttonDonation: 'button-donation',
    buttonGift: 'button-gift',
    buttonMultitier: 'button-mutitier',
    buttonCustomLink: 'button-custom-link',

    box: 'classic-box',
    boxSlim: 'classic-box-slim',
    boxRoundedModern: 'rounded-modern-box',
    boxWithLink: 'classic-box-link',
    boxWithText: 'classic-box-text',
    boxWithDiscount: 'classic-box-discount',
    upgradeBox: 'classic-upgrade-box',
    donationBox: 'classic-donation-box',
    boxNoButton: 'classic-box-no-button',

    popup: 'classic-popup',
    popupBox: 'classic-popup-box',
    popupWideModern: 'wide-modern-popup',
    popupBoxDiscount: 'classic-popup-box-discount',
    popupBoxLink: 'classic-popup-box-link',
    popupBoxUpgrade: 'classic-popup-box-upgrade',
    popupBoxNoButton: 'classic-popup-no-button',

    bottomSlideUpDiscount: 'classic-slideup-discount',
    bottomSlideUpLink: 'classic-slideup-link',
    bottomSlideUpUpgrade: 'classic-slideup-upgrade',
    bottomSlideUpWideModern: 'wide-modern-slideup',

    adLeaderBoard: 'ad-leaderboard',
    htmlBox: 'html-box',

    homepageOfferPopup: 'homepage-offer-popup',
    homepageSubscribePopup: 'homepage-subscribe-popup',

    gatedPdfSubscribePopup: 'gated-pdf-subscribe-popup',
    gatedPdfUpgradePopup: 'gated-pdf-upgrade-popup',

    paywallSubscribePopup: 'paywall-subscribe-popup',
    paywallUpgradePopup: 'paywall-upgrade-popup',
    paywallSubscribeBox: 'paywall-subscribe-box',
    paywallUpgradeBox: 'paywall-upgrade-box',

    campaignAdBanner: 'campaign-ad-banner',
    campaignAdSquare: 'campaign-ad-square',
}

const CTA_TYPE_POPUP = [
    CTA_TYPE.popup,
    CTA_TYPE.popupBox,
    CTA_TYPE.popupWideModern,
    CTA_TYPE.bottomSlideUpDiscount,
    CTA_TYPE.bottomSlideUpLink,
    CTA_TYPE.bottomSlideUpUpgrade,
    CTA_TYPE.bottomSlideUpWideModern,
    CTA_TYPE.popupBoxDiscount,
    CTA_TYPE.popupBoxLink,
    CTA_TYPE.popupBoxUpgrade,
    CTA_TYPE.popupBoxNoButton,
    CTA_TYPE.homepageOfferPopup,
    CTA_TYPE.homepageSubscribePopup,
    CTA_TYPE.gatedPdfSubscribePopup,
    CTA_TYPE.paywallSubscribePopup,
];

const CTA_TYPE_POPUP_SIGNIN = [
    CTA_TYPE.popup,
    CTA_TYPE.popupBox,
    CTA_TYPE.popupWideModern,
    CTA_TYPE.homepageSubscribePopup,
    CTA_TYPE.gatedPdfSubscribePopup,
    CTA_TYPE.gatedPdfSubscribePopup,
];

const CTA_TYPE_WITH_INPUT = [
    CTA_TYPE.box,
    CTA_TYPE.boxSlim,
    CTA_TYPE.popup,
    CTA_TYPE.popupBox,
    CTA_TYPE.popupWideModern,
    CTA_TYPE.bottomSlideUpWideModern,
    CTA_TYPE.homepageSubscribePopup,
    CTA_TYPE.gatedPdfSubscribePopup,
    CTA_TYPE.paywallSubscribePopup,
    CTA_TYPE.paywallSubscribeBox,
];

const CTA_TYPE_NO_TEXT = [
    CTA_TYPE.boxSlim,
];

const CTA_TYPE_AD = [
    CTA_TYPE.adLeaderBoard,
];

const CTA_TYPE_HTML = [
    CTA_TYPE.htmlBox,
];

const CTA_TYPE_BANNER_AD = [
    CTA_TYPE.campaignAdBanner,
    CTA_TYPE.campaignAdSquare,
];


const CTA_WITH_FREQUENCY = [
    CTA_TYPE.popup,
    CTA_TYPE.popupBox,
    CTA_TYPE.popupWideModern,
    CTA_TYPE.bottomSlideUpDiscount,
    CTA_TYPE.bottomSlideUpLink,
    CTA_TYPE.bottomSlideUpUpgrade,
    CTA_TYPE.bottomSlideUpWideModern,
    CTA_TYPE.popupBoxDiscount,
    CTA_TYPE.popupBoxLink,
    CTA_TYPE.popupBoxUpgrade,
    CTA_TYPE.popupBoxNoButton,
    CTA_TYPE.homepageOfferPopup,
    CTA_TYPE.homepageSubscribePopup,
];

const CTA_WITH_LABELS = [
    CTA_TYPE.popup,
    CTA_TYPE.popupBox,
    CTA_TYPE.popupWideModern,
    CTA_TYPE.bottomSlideUpWideModern,
    CTA_TYPE.box,
    CTA_TYPE.boxSlim,
    CTA_TYPE.homepageSubscribePopup,
    CTA_TYPE.gatedPdfSubscribePopup,
    CTA_TYPE.paywallSubscribePopup,
    CTA_TYPE.paywallUpgradePopup,
    CTA_TYPE.paywallSubscribeBox,
    CTA_TYPE.paywallUpgradeBox,
];

const CTA_WITH_IMAGE = [
    CTA_TYPE.popup,
    CTA_TYPE.popupBox,
    CTA_TYPE.popupWideModern,
    CTA_TYPE.bottomSlideUpDiscount,
    CTA_TYPE.bottomSlideUpLink,
    CTA_TYPE.bottomSlideUpUpgrade,
    CTA_TYPE.bottomSlideUpWideModern,
    CTA_TYPE.popupBoxDiscount,
    CTA_TYPE.popupBoxLink,
    CTA_TYPE.popupBoxUpgrade,
    CTA_TYPE.popupBoxNoButton,
    CTA_TYPE.homepageOfferPopup,
    CTA_TYPE.homepageSubscribePopup,
    CTA_TYPE.gatedPdfSubscribePopup,
    CTA_TYPE.gatedPdfUpgradePopup,
    CTA_TYPE.paywallSubscribePopup,
    CTA_TYPE.paywallUpgradePopup,

    CTA_TYPE.box,
    CTA_TYPE.boxRoundedModern,
    CTA_TYPE.boxWithLink,
    CTA_TYPE.boxWithText,
    CTA_TYPE.boxWithDiscount,
    CTA_TYPE.upgradeBox,
    CTA_TYPE.donationBox,
    CTA_TYPE.boxNoButton,
];

const CTA_TYPE_NO_BUTTON = [
    CTA_TYPE.popupBoxNoButton,
    CTA_TYPE.boxNoButton,
];

export const ctaModule = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
    AUDIENCES,
    STATUSES,
    SLOT_TYPE,
    CTA_TYPE,

    CTA_WITH_FREQUENCY,
    CTA_WITH_LABELS,
    CTA_WITH_IMAGE,

    CTA_TYPE_POPUP,
    CTA_TYPE_POPUP_SIGNIN,
    CTA_TYPE_WITH_INPUT,
    CTA_TYPE_NO_TEXT,
    CTA_TYPE_AD,
    CTA_TYPE_BANNER_AD,
    CTA_TYPE_HTML,
    CTA_TYPE_NO_BUTTON,

    AUTOPLACEMENT_AFTER,
    AUTOPLACEMENT_DIRECTIONS,
}
